var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a5.01 5.01 0 00-5 5c0 .398.09.758.18 1.113L0 9.293V13h4v-1h1v-1h.707l1.18-1.18c.355.09.715.18 1.113.18 2.754 0 5-2.246 5-5s-2.246-5-5-5zm0 1c2.215 0 4 1.785 4 4s-1.785 4-4 4c-.387 0-.766-.074-1.148-.188l-.282-.085L5.293 10H4v1H3v1H1V9.707L4.273 6.43l-.085-.282A4.035 4.035 0 014 5c0-2.215 1.785-4 4-4zm1 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z",
    fill: "#596F85",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseKey);
export default __webpack_public_path__ + "static/media/course-key.802cdeff9393d8c95f032968358819ff.svg";
export { ForwardRef as ReactComponent };